/** First-party anonymous visitor id — enables unique-open counting pre-auth. */
const KEY = 'campaign_visitor_id'

export function getVisitorId(): string {
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = `v_${crypto.randomUUID()}`
      localStorage.setItem(KEY, id)
    }
    return id
  } catch {
    // storage blocked — fall back to an ephemeral id for this page load.
    return `v_${Math.random().toString(36).slice(2)}`
  }
}
